<img class="spl-ui-spinner" src="splitory-ui/assets/images/spinner.svg" alt="" [style.width.px]="diameter()" />
